import { WooCommerceAccountBlock } from "@/integrations/wordpress/WooCommerceAccountBlock";
export default function Account() {
  return <section id="account-content" data-nav="light" className="bg-background text-foreground py-12 md:py-16 lg:py-24">
      <div className="max-w-[1240px] mx-auto px-5 md:px-8 lg:px-14">
        <div className="w-full">
          <WooCommerceAccountBlock />
        </div>
      </div>
    </section>;
}